import type { ReactNode } from "react";
import { StyleSheet, Text, View } from "react-native";

import {
  fonts,
  spacing,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

/** Visible + accessible label for freeform fields outside FormField. */
export function FieldLabel({
  children,
  hint,
}: {
  children: ReactNode;
  hint?: ReactNode;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <View style={stylesheet.wrap}>
      <Text style={stylesheet.label}>{children}</Text>
      {hint ? <Text style={stylesheet.hint}>{hint}</Text> : null}
    </View>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    wrap: { gap: spacing.xs },
    label: {
      color: colors.heading,
      fontFamily: fonts.semibold,
      fontSize: 13,
      letterSpacing: 0.2,
    },
    hint: {
      color: colors.mutedForeground,
      fontFamily: fonts.regular,
      fontSize: 12,
    },
  });
